


(function(){
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.25});
  document.querySelectorAll('.mood').forEach(function(m){io.observe(m);});
  /* word-by-word headline reveal */
  function split(el){
    var delay=0;
    Array.prototype.slice.call(el.childNodes).forEach(function(n){
      if(n.nodeType===3){
        var frag=document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(function(t){
          if(!t.trim()){frag.appendChild(document.createTextNode(t));return;}
          var w=document.createElement('span');w.className='w';
          var i=document.createElement('i');i.style.fontStyle='inherit';i.textContent=t;
          i.style.transitionDelay=(delay+=70)+'ms';
          w.appendChild(i);frag.appendChild(w);
        });
        el.replaceChild(frag,n);
      }else if(n.nodeType===1){
        var w=document.createElement('span');w.className='w';
        el.replaceChild(w,n);w.appendChild(n);
        n.style.transitionDelay=(delay+=70)+'ms';
      }
    });
  }
  var io2=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io2.unobserve(e.target);}});},{threshold:.4});
  document.querySelectorAll('h1.display,h2.display').forEach(function(el){
    if(el.closest('.mood'))return;
    split(el);el.classList.add('rev');io2.observe(el);
  });
  /* floating bar: hide while scrolling down, return on scroll-up or pause */
  var bar=document.querySelector('.sticky-cta');
  if(bar){
    var lastY=window.scrollY,idle;
    window.addEventListener('scroll',function(){
      var y=window.scrollY;
      if(y>lastY+8&&y>140){bar.classList.add('hide');}
      else if(y<lastY-8){bar.classList.remove('hide');}
      lastY=y;
      clearTimeout(idle);
      idle=setTimeout(function(){bar.classList.remove('hide');},600);
    },{passive:true});
  }
})();


